import { useEffect } from "react";
import ClearProfitStructure from "../../components/RefactoredHomePage/ClearProfitStructure";
import WhatMakesUsDifferent from "../../components/RefactoredHomePage/WhatMakesUsDifferent/WhatMakesUsDifferent";
import WhereEveryFundraiserSection from "../../components/RefactoredHomePage/WhereEveryFundraiserSection";
import SuccessStoriesSpeakForThemselves from "../../components/RefactoredHomePage/SuccessStories/SuccessStoriesSpeakForThemselves";
import { FundraiserNavigation } from "../../components/HomePageComponents";

const RefactoredHomePage = () => {
  useEffect(() => {
    document.title = "MamFam Home";
  }, []);
  return (
    <>
      <FundraiserNavigation />
      <WhereEveryFundraiserSection />
      <WhatMakesUsDifferent />
      <ClearProfitStructure />
      <SuccessStoriesSpeakForThemselves />
    </>
  );
};

export default RefactoredHomePage;
